import {Error, Label} from "@progress/kendo-react-labels";
import {DatePicker, TimePicker} from "@progress/kendo-react-dateinputs";
import * as React from "react";

const TimeField = fieldRenderProps => {
    const {
        validationMessage,
        visited,
        label,
        id,
        valid,
        ...others
    } = fieldRenderProps;
    return <>
        <Label editorId={id} className={"k-form-label"}>
            {label}
        </Label>
        <div className={"k-form-field-wrap"}>
            <TimePicker size={"large"} format={"HH:mm"} {...others} />
            {visited && validationMessage && <Error>{validationMessage}</Error>}
        </div>
    </>;
};

export default TimeField